import React, { useEffect } from "react"
import { useHistory, useLocation } from "react-router"
import { Link as RouterLink } from "react-router-dom"
import queryString from "query-string"
import { Typography, Link, Stack, useTheme, Box } from "@carrotfertility/carotene-core"
import { AppAccessPageLayout } from "#/components/access-page/AppAccessPageLayout"
import { AppAccessPageCard } from "#/components/access-page/AppAccessPageCard"
import { FormattedMessage, useIntl } from "react-intl"
import { EmployeeSupportUrl } from "../../utils/EmployeeSupportLink"

function SentEmailAuthCard({ email }: { email: string }) {
  const theme = useTheme()
  return (
    <AppAccessPageCard>
      <Box textAlign="center" marginBottom={(theme) => theme.spacing(theme.tokens.spacing.md)}>
        <Typography variant="h2" component="h1">
          <FormattedMessage defaultMessage="Check your inbox" />
        </Typography>
      </Box>
      <Stack
        spacing={theme.spacing(theme.tokens.spacing.xl)}
        marginBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}
      >
        <Stack spacing={theme.spacing(theme.tokens.spacing.xs)} textAlign="center">
          <Typography>
            <FormattedMessage defaultMessage="Check your email (including your spam folder) for an activation link from Carrot." />
          </Typography>
          <Typography>
            <FormattedMessage
              defaultMessage="Didn't get a link? <link>Verify with your name and date of birth</link> instead."
              values={{
                link: (linkContent) => (
                  <Link component={RouterLink} to={`/signup-find-account?email=${encodeURIComponent(email)}`}>
                    {linkContent}
                  </Link>
                )
              }}
            />
          </Typography>
          <Typography>
            <FormattedMessage
              defaultMessage="If you have any trouble, feel free to <link>contact us</link>."
              values={{
                link: (linkContent) => (
                  <Link href={EmployeeSupportUrl} target={"_blank"}>
                    {linkContent}
                  </Link>
                )
              }}
            />
          </Typography>
        </Stack>
      </Stack>
    </AppAccessPageCard>
  )
}

const signupPath = "/signup"

export default function SignUpSuccessPage() {
  const location = useLocation()
  const history = useHistory()
  const { email } = queryString.parse(location.search)
  const emailValue = Array.isArray(email) ? email[0] : email
  const intl = useIntl()

  useEffect(() => {
    if (!emailValue) {
      history.push(signupPath)
    }
  }, [emailValue, history])

  if (!emailValue) {
    return null
  }

  return (
    <AppAccessPageLayout title={intl.formatMessage({ defaultMessage: "Check your inbox" })}>
      <SentEmailAuthCard email={emailValue} />
    </AppAccessPageLayout>
  )
}
